import { Injectable, Signal, signal } from '@angular/core';
import { QueryParamsCallBack, RedirectModel } from './callback.model';

@Injectable({
  providedIn: 'root'
})
export class CallbackStore {
  private readonly defaultState: RedirectModel | null = null;
  private readonly stateSignal = signal<RedirectModel | null>(this.defaultState);

  get value(): Signal<RedirectModel | null> {
    return this.stateSignal;
  }

  update(urls: string[], queryParams: QueryParamsCallBack): void {
    const redirect: RedirectModel = {
      page: urls[0],
      id: urls[1],
      subPage: urls[2],
      queryParams
    };
    this.stateSignal.update(() => redirect);
  }

  updateRedirectModel(redirectModel: RedirectModel): void {
    this.stateSignal.update(() => redirectModel);
  }
}
